module.exports = __webpack_public_path__ + "img/93.8.TSS.87a2e606.png";